import { useMutation, type UseMutationResult } from "@tanstack/react-query";
import { useChipiContext } from "../context";
import type { ApproveHookInput } from "@chipi-stack/types";

type ApproveInput = {
  params: ApproveHookInput;
  bearerToken: string;
};



/**
 * Hook for approving token spending
 */
export function useApprove(): {
  approve: (params: ApproveInput) => void;
  approveAsync: (params: ApproveInput) => Promise<string>;
  data: string | undefined;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
  isSuccess: boolean;
  reset: () => void;
} {
  const { chipiSDK } = useChipiContext();

  const mutation: UseMutationResult<string, Error, ApproveInput> = useMutation({
    mutationFn: (params: ApproveInput) => chipiSDK.approve({
      params: {
        ...params.params,
        amount: String(params.params.amount),
      },
      bearerToken: params.bearerToken,
    }),
  });

  return {
    approve: mutation.mutate,
    approveAsync: mutation.mutateAsync,
    data: mutation.data,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    isSuccess: mutation.isSuccess,
    reset: mutation.reset,
  };
}
